import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  CLOSE_ALERT,
  closeAlertFail,
  closeAlertSuccess,
  GET_ALERT_DETAIL,
  GET_CLUSTER_VIEW_DESCRIPTION,
  GET_COUNTRIES,
  GET_FEATURE_CATEGORY_TYPES,
  GET_HIST_ALERT,
  GET_HIST_ALERT_HEADER,
  GET_LINKED_CUSTOMERS_C2C,
  GET_RISK_INDICATORS,
  GET_RISK_INDICATORS_GRAPH,
  GET_TRANSACTION,
  GET_TRANSACTION_PRODUCT_MAPPING,
  GET_TRANSACTION_TYPES,
  getAlertDetailFail,
  getAlertDetailSuccess,
  getClusterInformationSuccess,
  getClusterViewDescriptionFail,
  getClusterViewDescriptionSuccess,
  getCountriesFail,
  getCountriesSuccess,
  getCustomerProfileSuccess,
  getFeatureCategoryFail,
  getFeatureCategorySuccess,
  getFeatureCodesSuccess,
  getHistAlertFail,
  getHistAlertHeaderSuccess,
  getHistAlertSuccess,
  getLinkedCustomersC2CFail,
  getLinkedCustomersC2CSuccess,
  getModelExplainabilitySuccess,
  getRiskIndicatorsFail,
  getRiskIndicatorsGraphFail,
  getRiskIndicatorsGraphSuccess,
  getRiskIndicatorsSuccess,
  getTransactionFail,
  getTransactionProductMappingFail,
  getTransactionProductMappingSuccess,
  getTransactionSuccess,
  getTransactionTypesFail,
  getTransactionTypesSuccess
} from '../../redux/actions/tm/investigationDetail';

import * as api from '../../services/tm/investigationDetail';

// get alert detail
export function* watchGetAlertDetail() {
  yield takeEvery(GET_ALERT_DETAIL, function* ({ payload }) {
    yield fork(getAlertDetailWorker, payload);
  });
}

function* getAlertDetailWorker(payload) {
  try {
    // fetch alert details
    const response = yield call(api.getAlertDetail, payload);
    yield put(getAlertDetailSuccess(response));

    // then, fetch risk indicators for whole TM
    const riskIndicators = yield call(api.getRiskIndicators, null);

    yield put(getRiskIndicatorsSuccess(riskIndicators));

    // if there is sufficient response data, retrieve other data related to the alert details
    if (response?.customer_id) {
      try {
        // get customer profile related to the alert details
        const customerProfileResponse = yield call(
          api.getCustomerProfile,
          response
        );

        // if there's response, get graph data for risk indicators
        if (customerProfileResponse) {
          const customerAssociatedAccountsResponse = yield call(
            api.getCustomerAsssociatedAccounts,
            response
          );

          try {
            const riskIndicatorsGraphPayload = {
              ...response,
              modelId: response.modelId,
              riskIndicator: riskIndicators.data[0]
            };
            customerProfileResponse['risk_indicators'] = yield call(
              api.getRiskIndicatorsGraph,
              riskIndicatorsGraphPayload
            );
          } catch (error) {}
          customerProfileResponse[
            'associated_accounts'
          ] = customerAssociatedAccountsResponse;
          yield put(getCustomerProfileSuccess(customerProfileResponse));
        }
      } catch (err) {}

      try {
        // get alert history
        const customerAlertHistory = yield call(
          api.getCustomerAlertHistory,
          response
        );
        yield put(getHistAlertSuccess(customerAlertHistory));
      } catch (err) {}

      try {
        // get c2c api
        const linkedCustomers = yield call(api.getC2CLinkedCustomers, response);
        yield put(getLinkedCustomersC2CSuccess(linkedCustomers));
      } catch (err) {}

      try {
        // get transaction history
        const customerTransactionHistory = yield call(
          api.getCustomerTransactionHistory,
          response
        );
        yield put(getTransactionSuccess(customerTransactionHistory));
      } catch (err) {}

      try {
        const transactionProductMappingData = yield call(
          api.getTransactionProductMapping,
          null
        );
        window.localStorage.setItem(
          'transactionProductMapping',
          JSON.stringify(transactionProductMappingData.data)
        );
      } catch (err) {}

      try {
        const featureTypeIdentifiers = window.localStorage.getItem(
          'featureTypeIdentifiers'
        );
        const featureCodes = window.localStorage.getItem('featureCodes');
        if (featureTypeIdentifiers && featureCodes) {
          const parsedFeatureCodes = JSON.parse(featureCodes);
          const parsedfeatureIdentifiers = JSON.parse(featureTypeIdentifiers);
          yield put(getFeatureCodesSuccess({ data: parsedFeatureCodes }));

          const alertModelExplainability = yield call(
            api.getModelExplainability,
            {
              ...response,
              featureCodes: parsedFeatureCodes ? parsedFeatureCodes : null,
              featureTypes: parsedfeatureIdentifiers
                ? parsedfeatureIdentifiers
                : null
            }
          );
          yield put(getModelExplainabilitySuccess(alertModelExplainability));
        } else {
          const featureCodesData = yield call(api.getFeatureCodes, null);
          const featureTypeIdentifiers = yield call(
            api.getFeatureTypeIdentifiers,
            null
          );
          window.localStorage.setItem(
            'featureTypeIdentifiers',
            JSON.stringify(featureTypeIdentifiers.data)
          );
          window.localStorage.setItem(
            'featureCodes',
            JSON.stringify(featureCodesData.data)
          );
          yield put(getFeatureCodesSuccess(featureCodesData));

          const alertModelExplainability = yield call(
            api.getModelExplainability,
            {
              ...response,
              featureCodes: featureCodesData?.data
                ? featureCodesData.data
                : null,
              featureTypes: featureTypeIdentifiers.data
            }
          );
          yield put(getModelExplainabilitySuccess(alertModelExplainability));
        }
      } catch (err) {}

      try {
        const transactionTypesFilterData = yield call(
          api.getTransactionTypes,
          null
        );
        yield put(getTransactionTypesSuccess(transactionTypesFilterData));
      } catch (err) {}

      try {
        const featureCategoryFilterData = yield call(
          api.getFeatureCategoryCodes,
          null
        );
        window.localStorage.setItem(
          'featureCategoryCodes',
          JSON.stringify(featureCategoryFilterData.data)
        );
        yield put(getFeatureCategorySuccess(featureCategoryFilterData));
      } catch (err) {}

      try {
        const clusterViewDescriptionData = yield call(
          api.getClusterViewDescription,
          null
        );
        window.localStorage.setItem(
          'clusterViewDescription',
          JSON.stringify(clusterViewDescriptionData.data)
        );
        yield put(getClusterViewDescriptionSuccess(clusterViewDescriptionData));

        if (clusterViewDescriptionData) {
          const clusterInformation = yield call(
            api.getClusterInformation,
            response
          );
          yield put(getClusterInformationSuccess(clusterInformation));
        }
      } catch (err) {}
    }
  } catch (error) {
    yield put(getAlertDetailFail());
  }
}

// get transaction
export function* watchgetTransaction() {
  yield takeEvery(GET_TRANSACTION, function* ({ payload }) {
    yield fork(getTransactionWorker, payload);
  });
}

function* getTransactionWorker(payload) {
  try {
    const response = yield call(api.getCustomerTransactionHistory, payload);
    yield put(getTransactionSuccess(response));
  } catch (error) {
    yield put(getTransactionFail());
  }
}

//hist alert header
export function* watchgetHistAlertHeader() {
  yield takeEvery(GET_HIST_ALERT_HEADER, function* ({ payload }) {
    yield fork(getHistAlertHeaderWorker, payload);
  });
}

function* getHistAlertHeaderWorker(payload) {
  try {
    const response = yield call(api.getHistAlertHeader, payload);
    yield put(getHistAlertHeaderSuccess(response));
  } catch (error) {
    //silence failure
  }
}

//hist alert
export function* watchGetHistAlert() {
  yield takeEvery(GET_HIST_ALERT, function* ({ payload }) {
    yield fork(getHistAlertWorker, payload);
  });
}

function* getHistAlertWorker(payload) {
  try {
    const response = yield call(api.getCustomerAlertHistory, payload);
    yield put(getHistAlertSuccess(response));
  } catch (error) {
    yield put(getHistAlertFail());
  }
}

// linked customers
export function* watchGetLinkedCustomerAlert(payload) {
  yield takeEvery(GET_LINKED_CUSTOMERS_C2C, function* ({ payload }) {
    yield fork(getLinkedCustomerWorker, payload);
  });
}

function* getLinkedCustomerWorker(payload) {
  try {
    const response = yield call(api.getC2CLinkedCustomers, payload);
    yield put(getLinkedCustomersC2CSuccess(response));
  } catch (error) {
    yield put(getLinkedCustomersC2CFail());
  }
}

// get risk indicators
export function* watchGetRiskIndicators() {
  yield takeEvery(GET_RISK_INDICATORS, function* ({ payload }) {
    yield fork(getRiskIndicatorsWorker, payload);
  });
}

function* getRiskIndicatorsWorker(payload) {
  try {
    const response = yield call(api.getRiskIndicators);
    yield put(getRiskIndicatorsSuccess(response));
  } catch (error) {
    yield put(getRiskIndicatorsFail());
  }
}

// get risk indicators graph
export function* watchGetRiskIndicatorsGraph() {
  yield takeEvery(GET_RISK_INDICATORS_GRAPH, function* ({ payload }) {
    yield fork(getRiskIndicatorsGraphWorker, payload);
  });
}

function* getRiskIndicatorsGraphWorker(payload) {
  try {
    const response = yield call(api.getRiskIndicatorsGraph, payload);
    yield put(getRiskIndicatorsGraphSuccess(response));
  } catch (error) {
    yield put(getRiskIndicatorsGraphFail());
  }
}

// get countries
export function* watchGetCountries() {
  yield takeEvery(GET_COUNTRIES, function* ({ payload }) {
    yield fork(getCountriesDataWorker, payload);
  });
}

function* getCountriesDataWorker(payload) {
  try {
    const response = yield call(api.getCountries, null);
    yield put(getCountriesSuccess(response));
  } catch (error) {
    yield put(getCountriesFail());
  }
}

// get transaction types
export function* watchGetTransactionTypes() {
  yield takeEvery(GET_TRANSACTION_TYPES, function* ({ payload }) {
    yield fork(getTransactionTypesDataWorker, payload);
  });
}

function* getTransactionTypesDataWorker(payload) {
  try {
    const response = yield call(api.getTransactionTypes, null);
    yield put(getTransactionTypesSuccess(response));
  } catch (error) {
    yield put(getTransactionTypesFail());
  }
}

// get clusterViewDescriptionData types
export function* watchGetClusterViewDescription() {
  yield takeEvery(GET_CLUSTER_VIEW_DESCRIPTION, function* ({ payload }) {
    yield fork(getClusterViewDescriptionWorker, payload);
  });
}

function* getClusterViewDescriptionWorker(payload) {
  try {
    const response = yield call(api.getClusterViewDescription(), null);
    yield put(getClusterViewDescriptionSuccess(response));
  } catch (error) {
    yield put(getClusterViewDescriptionFail());
  }
}

export function* watchGetFeatureCategoryTypes() {
  yield takeEvery(GET_FEATURE_CATEGORY_TYPES, function* ({ payload }) {
    yield fork(GetFeatureCategoryDataWorker, payload);
  });
}

function* GetFeatureCategoryDataWorker(payload) {
  try {
    const response = yield call(api.getFeatureCategoryCodes, null);
    yield put(getFeatureCategorySuccess(response));
  } catch (error) {
    yield put(getFeatureCategoryFail());
  }
}

export function* watchGetTransactionProductMapping() {
  yield takeEvery(GET_TRANSACTION_PRODUCT_MAPPING, function* ({ payload }) {
    yield fork(GetTransactionProductMappingWorker, payload);
  });
}

function* GetTransactionProductMappingWorker(payload) {
  try {
    const response = yield call(api.getTransactionProductMapping, null);
    yield put(getTransactionProductMappingSuccess(response));
  } catch (error) {
    yield put(getTransactionProductMappingFail());
  }
}

// get alert history
export function* watchGetAlertHistory() {
  yield takeEvery(GET_HIST_ALERT, function* ({ payload }) {
    yield fork(getAlertHistoryDataWorker, payload);
  });
}

function* getAlertHistoryDataWorker(payload) {
  try {
    const response = yield call(api.getCustomerAlertHistory, payload);
    yield put(getHistAlertSuccess(response));
  } catch (error) {
    yield put(getHistAlertFail({}));
  }
}

// close alert
export function* watchCloseAlert() {
  yield takeEvery(CLOSE_ALERT, function* ({ payload }) {
    yield fork(closeAlertDataWorker, payload);
  });
}

function* closeAlertDataWorker(payload) {
  try {
    const response = yield call(api.postCloseAlert, payload);
    yield put(closeAlertSuccess(response));
  } catch (error) {
    yield put(
      closeAlertFail({ message: 'Something went wront, please try again.' })
    );
  }
}
